import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M12.7803 5.53033C13.0732 5.23744 13.0732 4.76256 12.7803 4.46967C12.4874 4.17678 12.0126 4.17678 11.7197 4.46967L4.71967 11.4697C4.42678 11.7626 4.42678 12.2374 4.71967 12.5303L11.7197 19.5303C12.0126 19.8232 12.4874 19.8232 12.7803 19.5303C13.0732 19.2374 13.0732 18.7626 12.7803 18.4697L6.31066 12L12.7803 5.53033ZM18.7803 5.53033C19.0732 5.23744 19.0732 4.76256 18.7803 4.46967C18.4874 4.17678 18.0126 4.17678 17.7197 4.46967L10.7197 11.4697C10.4268 11.7626 10.4268 12.2374 10.7197 12.5303L17.7197 19.5303C18.0126 19.8232 18.4874 19.8232 18.7803 19.5303C19.0732 19.2374 19.0732 18.7626 18.7803 18.4697L12.3107 12L18.7803 5.53033Z',
                    fill: '#82869E',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const JumpBackOutlined = React.forwardRef(IconComponent);
JumpBackOutlined.displayName = 'JumpBackOutlined';

export { JumpBackOutlined };
